import React from "react";
import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  Calendar,
  Clock,
  Edit,
  MoreVertical,
  Users,
  Eye,
  XCircle,
  FileText,
  Briefcase,
  FileUserIcon,
  SearchCheck,
  SearchIcon,
  ChevronDown,
  ChevronUp,
} from "lucide-react";
import usePaginationStore from "@/hooks/stores/usePaginationStore";
import Pagination from "../Common/Pagination";

const VacancyTable = ({
  vacancies,
  handleEdit,
  handleDelete,
  handleStatusChange,
  setActiveTab,
  setCampaignId,
  handleApplicantsClick,
  onVacanciesClick,
  onApplicantsClick,
  companyId,
  showApplicants = true,
  handleSearchChange = null,
  noVacancyMessage = "No Vaccancy Created yet",
  searchTerm = "",
  serverPagination,
  onPageChange,
  onPerPageChange,
}) => {
  const navigate = useNavigate();
  const { getPerPage, setPerPage } = usePaginationStore();

  const [searchQuery, setSearchQuery] = useState(searchTerm);
  const searchLower = searchQuery.toLowerCase();

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchQuery(value);
    if (handleSearchChange) {
      handleSearchChange(value);
    }
  };

  const currentVacancies = vacancies;

  const [activeMenu, setActiveMenu] = useState(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if the click is outside the dropdown and its children
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setActiveMenu(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const formatTime = (timeString) => {
    const [hours, minutes, seconds] = timeString.split(":");
    return `${hours}:${minutes}`;
  };
  const menuRef = useRef(null);
  const [statusMenu, setStatusMenu] = useState(null);
  return (
    <>
      {vacancies.length > 0 ? (
        <div className="bg-card shadow rounded-lg">
          <table className="min-w-full divide-y divide-border">
            <thead className="bg-muted border-b border-border">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-semibold text-muted-foreground uppercase tracking-wider">
                  Vacancy Details
                </th>
                <th className="px-6 py-5 text-left text-xs font-semibold text-muted-foreground uppercase tracking-wider">
                  Status
                </th>
                {showApplicants && (
                  <th className="px-6 py-5 text-left text-xs font-semibold text-muted-foreground uppercase tracking-wider">
                    Applicants
                  </th>
                )}
                <th className="px-6 py-5 text-left text-xs font-semibold text-muted-foreground uppercase tracking-wider">
                  Tags
                </th>
                <th className="px-6 py-5 text-left text-xs font-semibold text-muted-foreground uppercase tracking-wider">
                  Timeline
                </th>
                <th className="px-6 py-5 text-center text-xs font-semibold text-muted-foreground uppercase tracking-wider">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-card divide-y divide-border">
              {currentVacancies.map((vacancy) => (
                <tr key={vacancy.id} className="hover:bg-muted">
                  <td className="px-6 py-4 ">
                    <div className="flex flex-col">
                      <div
                        onClick={() => {
                          // window.location.href = `/campaigns/${vacancy.campaign.id}/vacancies/${vacancy.id}`
                          onApplicantsClick(vacancy);
                        }}
                        className="text-md font-medium text-foreground mb-1 cursor-pointer hover:text-indigo-600 transition-colors"
                      >
                        {vacancy.title}
                      </div>
                      <div className="text-xs text-muted-foreground">
                        {vacancy.campaign?.title}
                      </div>
                    </div>
                  </td>

                  <td className="px-6 py-4">
                    <div className="flex items-center space-x-2">
                      <div className="relative">
                        {vacancy.status == 2 ? (
                          <span
                            className={`px-2 py-1 text-xs font-semibold rounded-full bg-red-100 text-red-800`}
                          >
                            Archived
                          </span>
                        ) : (
                          <div className="relative inline-block text-left">
                            <span
                              className={`px-2 py-1 text-xs font-semibold rounded-full ${
                                vacancy.status == 1
                                  ? "bg-green-100 text-green-800 cursor-pointer"
                                  : vacancy.status == 2
                                    ? "bg-red-100 text-red-800  cursor-pointer"
                                    : "bg-yellow-100 text-yellow-800 cursor-pointer"
                              } self-start flex items-center gap-1`}
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                if (vacancy.status != 2) {
                                  setStatusMenu(
                                    statusMenu == vacancy.id
                                      ? null
                                      : vacancy.id,
                                  );
                                }
                              }}
                            >
                              {vacancy.status == 1
                                ? "Published"
                                : vacancy.status == 2
                                  ? "Archived"
                                  : "Draft"}
                              {vacancy.status != 2 &&
                                (statusMenu === vacancy.id ? (
                                  <ChevronUp className="h-3 w-3 mt-[3px]" />
                                ) : (
                                  <ChevronDown className="h-3 w-3 mt-[3px]" />
                                ))}
                            </span>
                            {statusMenu == vacancy.id && (
                              <>
                                <div
                                  className="fixed inset-0 z-[99]"
                                  onClick={() => setStatusMenu(null)}
                                ></div>
                                <div
                                  className="absolute transform translate-x-[-30%] mt-2 w-56 origin-top-right bg-card rounded-lg shadow-lg ring-1 ring-border z-[100] divide-y divide-border"
                                  onClick={() => setStatusMenu(null)}
                                >
                                  {vacancy.status == 1 && (
                                    <>
                                      <button
                                        onClick={(e) => {
                                          e.preventDefault();
                                          e.stopPropagation();
                                          handleStatusChange(vacancy.id, 0);
                                          setStatusMenu(null);
                                        }}
                                        className="flex items-center w-full px-4 py-3 text-sm text-foreground hover:bg-muted transition-colors duration-150"
                                      >
                                        <FileText className="h-4 w-4 mr-3 text-muted-foreground" />
                                        Mark as Draft
                                      </button>
                                      <button
                                        onClick={(e) => {
                                          e.preventDefault();
                                          e.stopPropagation();
                                          handleStatusChange(vacancy.id, 2);
                                          setStatusMenu(null);
                                        }}
                                        className="flex items-center w-full px-4 py-3 text-sm text-red-600 hover:bg-red-50 transition-colors duration-150"
                                      >
                                        <XCircle className="h-4 w-4 mr-3 text-red-400" />
                                        Archive
                                      </button>
                                    </>
                                  )}
                                  {vacancy.status == 0 && (
                                    <>
                                      <button
                                        onClick={(e) => {
                                          e.preventDefault();
                                          e.stopPropagation();
                                          handleStatusChange(vacancy.id, 1);
                                          setStatusMenu(null);
                                        }}
                                        className="flex items-center w-full px-4 py-3 text-sm text-foreground hover:bg-muted transition-colors duration-150"
                                      >
                                        <FileText className="h-4 w-4 mr-3 text-muted-foreground" />
                                        Publish
                                      </button>
                                      <button
                                        onClick={(e) => {
                                          e.preventDefault();
                                          e.stopPropagation();
                                          handleStatusChange(vacancy.id, 2);
                                          setStatusMenu(null);
                                        }}
                                        className="flex items-center w-full px-4 py-3 text-sm text-red-600 hover:bg-red-50 transition-colors duration-150"
                                      >
                                        <XCircle className="h-4 w-4 mr-3 text-red-400" />
                                        Archive
                                      </button>
                                    </>
                                  )}
                                </div>
                              </>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </td>

                  {showApplicants && (
                    <td className="px-6 py-4">
                      <div className="flex items-center gap-4">
                        {/* Left: User Icon */}
                        <Users className="h-5 w-5 text-muted-foreground mt-1" />

                        {/* Right: Text Info */}
                        <div className="flex flex-col gap-1">
                          {/* New Applicants */}
                          {vacancy?.newApplicants > 0 && (
                            <div
                              className="relative group cursor-pointer text-md text-foreground font-medium hover:text-green-700 text-left"
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();

                                window.open(
                                  `/vacancies/${vacancy.id}/pre-screen`,
                                  "_blank",
                                );
                              }}
                            >
                              {vacancy.newApplicants} New
                              <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 text-xs text-background bg-foreground border border-border rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap pointer-events-none">
                                {vacancy.newApplicants === 0
                                  ? "No Applied Applicants"
                                  : "New Applicants"}
                              </div>
                            </div>
                          )}
                          {/* View All Applicants */}
                          <button
                            onClick={() => {
                              onApplicantsClick(vacancy);
                            }}
                            className="text-sm text-muted-foreground font-medium  text-left"
                          >
                            View all applicants
                          </button>
                        </div>
                      </div>
                    </td>
                  )}

                  <td className="px-6 py-4">
                    <div className="flex flex-wrap gap-1">
                      {vacancy.tags?.map((tag, index) => (
                        <span
                          key={index}
                          className="px-2 py-1 text-xs font-medium bg-indigo-100 text-indigo-800 rounded-full"
                        >
                          {tag}
                        </span>
                      ))}
                    </div>
                  </td>

                  <td className="px-6 py-4">
                    <div className="flex items-center">
                      <Calendar className="h-4 w-4 text-muted-foreground mr-2" />
                      <span className="text-sm text-foreground">
                        {new Date(vacancy.startDate).toLocaleDateString(
                          "en-GB",
                        )}{" "}
                        -{" "}
                        {new Date(vacancy.endDate).toLocaleDateString("en-GB")}
                      </span>
                    </div>
                  </td>

                  <td className="px-6 py-4 text-center text-sm font-medium">
                    <div className="flex items-center justify-center space-x-3">
                      <button
                        onClick={() => {
                          window.location.href = `/campaigns/${vacancy.campaign.id}/vacancies/${vacancy.id}`;
                        }}
                        className="text-muted-foreground hover:text-muted-foreground relative group"
                      >
                        <Edit className="h-5 w-5" />
                        <div className="absolute bottom-full right-0 mb-2 px-2 py-1 text-xs text-background bg-foreground border border-border rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap pointer-events-none">
                          Edit Vacancy
                        </div>
                      </button>
                      {vacancy.status != 2 && (
                        <div className="relative">
                          <div className="relative inline-block text-left">
                            <button
                              className={`text-muted-foreground hover:text-muted-foreground rounded-full p-1 hover:bg-muted focus:outline-none focus:ring-2 focus:ring-indigo-500 ${
                                activeMenu === vacancy.id ? "bg-muted" : ""
                              }`}
                              onClick={(e) => {
                                e.stopPropagation();
                                setActiveMenu(vacancy.id);
                              }}
                            >
                              <MoreVertical className="h-5 w-5" />
                            </button>
                            {activeMenu === vacancy.id && (
                              <div
                                ref={menuRef}
                                className={`${activeMenu == vacancy.id ? "" : "hidden"} absolute transform translate-x-[-90%] mt-2 w-56 origin-top-right bg-card rounded-lg shadow-lg ring-1 ring-border z-[100] divide-y divide-border`}
                                onClick={(e) => e.stopPropagation()}
                              >
                                {vacancy.newApplicants > 0 && (
                                  <a
                                    href={`/vacancies/${vacancy.id}/pre-screen`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="flex items-center px-4 py-3 text-sm text-foreground hover:bg-muted transition-colors duration-150"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setActiveMenu(null);
                                    }}
                                  >
                                    {/* <span className="h-4 w-4 mr-3 text-muted-foreground"></span> */}
                                    {/* <SearchCheck className="h-4 w-4 mr-3 text-muted-foreground" /> */}
                                    Review new applications
                                  </a>
                                )}
                                {showApplicants && (
                                  <a
                                    href="#"
                                    className="flex items-center px-4 py-3 text-sm text-foreground hover:bg-muted rounded-t-lg transition-colors duration-150"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      onApplicantsClick(vacancy);
                                    }}
                                  >
                                    {/* <span className="h-4 w-4 mr-3 text-muted-foreground"></span> */}
                                    View applicants tracker
                                  </a>
                                )}
                                <a
                                  href="#"
                                  className="flex items-center px-4 py-3 text-sm text-foreground hover:bg-muted transition-colors duration-150"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    console.log("vacancy", vacancy);
                                    navigator.clipboard.writeText(
                                      `${window.location.origin}/${vacancy.slug}`,
                                    );
                                    setActiveMenu(null);
                                  }}
                                >
                                  {/* <span className="h-4 w-4 mr-3 text-muted-foreground"></span> */}
                                  Copy Direct Link
                                </a>

                                {vacancy.status == 1 && (
                                  <>
                                    <button
                                      onMouseDown={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        handleStatusChange(vacancy.id, 0);
                                      }}
                                      className="flex items-center w-full px-4 py-3 text-sm text-foreground hover:bg-muted transition-colors duration-150"
                                    >
                                      {/* <span className="h-4 w-4 mr-3 text-muted-foreground"></span> */}
                                      {/* <FileText className="h-4 w-4 mr-3 text-muted-foreground" /> */}
                                      Mark as Draft
                                    </button>
                                    <button
                                      onMouseDown={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        handleStatusChange(vacancy.id, 2);
                                      }}
                                      className="flex items-center w-full px-4 py-3 text-sm text-red-600 hover:bg-red-50 transition-colors duration-150"
                                    >
                                      {/* <XCircle className="h-4 w-4 mr-3 text-red-400" /> */}
                                      Archive
                                    </button>
                                  </>
                                )}
                                {vacancy.status == 0 && (
                                  <>
                                    <button
                                      onMouseDown={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        handleStatusChange(vacancy.id, 1);
                                      }}
                                      className="flex items-center w-full px-4 py-3 text-sm text-foreground hover:bg-muted transition-colors duration-150"
                                    >
                                      {/* <FileText className="h-4 w-4 mr-3 text-muted-foreground" /> */}
                                      Publish
                                    </button>
                                    <button
                                      onMouseDown={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        handleStatusChange(vacancy.id, 2);
                                      }}
                                      className="flex items-center w-full px-4 py-3 text-sm text-red-600 hover:bg-red-50 transition-colors duration-150"
                                    >
                                      {/* <XCircle className="h-4 w-4 mr-3 text-red-400" /> */}
                                      Archive
                                    </button>
                                  </>
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="flex justify-center items-center h-24">
          <p className="text-muted-foreground text-lg">{noVacancyMessage}</p>
        </div>
      )}

      {/* Pagination Controls */}
      {serverPagination && (
        <Pagination
          currentPage={serverPagination?.current_page}
          totalPages={serverPagination?.last_page}
          per_page={serverPagination?.per_page}
          onPerPageChange={onPerPageChange}
          onPageChange={onPageChange}
        />
      )}
    </>
  );
};

export default VacancyTable;
